/* global process */
let base = window._env_.VUE_APP_IMG_FLOW_HOST
export const getImgFlowConfigTable = params => {
  return axios.get(`${base}/read_flow_list`, {params})
}
export const getImgFlowConfigDetail = params => {
  return axios.get(`${base}/read_flow_detail/${params.id}`, {params})
}
export const createImgFlowConfigData = params => {
  return axios.post(`${base}/create_flow`, params)
}
export const updateImgFlowConfigData = params => {
  return axios.post(`${base}/update_flow/${params.id}`, params)
}
export const deleteImgFlowConfigData = params => {
  return axios.post(`${base}/deleteImgFlowConfigData/${params.id}`, params)
}
export const copyImgFlowConfig = params => {
  return axios.post(`${base}/create_flow/copy/${params.id}`, params)
}
export const closeImgFlowConfig = params => {
  return axios.post(`${base}/update_flow/close/${params.id}`, params)
}
export const openImgFlowConfig = params => {
  return axios.post(`${base}/update_flow/open/${params.id}`, params)
}
export const resetImgFlowConfig = params => {
  return axios.post(`${base}/update_flow/reset_result/${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/img-flow-config/img-flow-config.api.js